export const handleSortItemsByPosition = (items) => items.sort(({position: positionA}, {position: positionB}) => positionA - positionB);
